import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, input, model, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';

import { FormLabelComponent } from '@ui-kit/form/form-label/form-label.component';

@Component({
    selector: 'input-text',
    standalone: true,
    imports: [
        FormLabelComponent,
        TranslateModule,
        InputTextModule,
        FormsModule,
        IconFieldModule,
        InputIconModule,
        TooltipModule,
        NgTemplateOutlet,
    ],
    templateUrl: './input-text.component.html',
    styleUrl: './input-text.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputTextComponent {
    id = input.required<string>();
    value = model.required<string>();

    label = input<string>('');
    tooltipText = input<string>('');
    required = input<boolean>(false);
    invalid = input<boolean>(false);
    size = input<'small' | 'large'>('large');

    placeholder = input<string>('uiKit.form.inputText.placeholder');
    disabled = input<boolean>(false);
    maxLength = input<number>(500);
    type = input<'text' | 'email' | 'password'>('text');
    showClearIcon = input<boolean>(false);

    tooltipError = input<string | undefined>(undefined);
    tooltipErrorPlacement = input<'top' | 'bottom' | 'right' | 'left'>('right');

    shouldHandleTooltipFocus = signal<boolean>(false);

    // used to handle border radius if the button is glued to another element
    glueRight = input<boolean>(false);
    glueLeft = input<boolean>(false);

    onFocus = output<string>();
    onBlur = output<string>();

    constructor() {
        effect(() => {
            if (this.shouldHandleTooltipFocus() && this.tooltipError() !== undefined) {
                document.getElementById(this.id())?.focus();
            }
        });
    }

    inputFocus(): void {
        if (!this.shouldHandleTooltipFocus()) {
            this.shouldHandleTooltipFocus.set(true);
        }

        this.onFocus.emit(this.value());
    }

    clearInput(event: Event): void {
        if (this.disabled()) {
            return;
        }

        event.stopPropagation();
        this.value.set('');
    }
}
